var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineCopySuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9 1.25c-3.91 0-5.65 1.74-5.65 5.65V8c0 .41.34.75.75.75h3.1c3.1 0 4.15 1.05 4.15 4.15V16c0 .41.34.75.75.75h1.1c3.91 0 5.65-1.74 5.65-5.65V6.9c0-3.91-1.74-5.65-5.65-5.65h-4.2zM8.75 6.9c0-3.1 1.05-4.15 4.15-4.15h4.2c3.1 0 4.15 1.05 4.15 4.15v4.2c0 3.1-1.05 4.15-4.15 4.15h-.35V12.9c0-3.91-1.74-5.65-5.65-5.65H8.75V6.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9 7.25c-3.91 0-5.65 1.74-5.65 5.65v4.2c0 3.91 1.74 5.65 5.65 5.65h4.2c3.91 0 5.65-1.74 5.65-5.65v-4.2c0-3.91-1.74-5.65-5.65-5.65H6.9zM2.75 17.1v-4.2c0-3.1 1.05-4.15 4.15-4.15h4.2c3.1 0 4.15 1.05 4.15 4.15v4.2c0 3.1-1.05 4.15-4.15 4.15H6.9c-3.1 0-4.15-1.05-4.15-4.15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.5 17.48-1.95-1.95a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l1.42 1.42 3.36-3.36c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-3.9 3.89c-.14.14-.33.22-.52.22s-.38-.07-.53-.22z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineCopySuccess);
export default __webpack_public_path__ + "static/media/vuesax-outline-copy-success.43818c2365e30ee4c38e71551ee78a4f.svg";
export { ForwardRef as ReactComponent };